import { SyncedCharacterController } from "../synced_character_controller";

export class PlayerCharacterController extends SyncedCharacterController {

    constructor() {
        super();
    }
}